import { api } from './api';
import type { ReportDetail, ReportListResponse, TaskStatus, RetryResponse } from '../types';

export interface ReportQuery {
  page: number;
  pageSize: number;
  status?: TaskStatus | '';
}
export const reportsService = {
  list(query: ReportQuery, signal?: AbortSignal) {
    const params = new URLSearchParams({
      page: String(query.page),
      page_size: String(query.pageSize)
    });
    if (query.status) params.set('status', query.status);
    return api.get<ReportListResponse>(`/reports?${params.toString()}`, signal);
  },
  detail(taskId: string, signal?: AbortSignal) {
    return api.get<ReportDetail>(`/reports/${encodeURIComponent(taskId)}`, signal);
  },
  retry(taskId: string, articleId: string, signal?: AbortSignal) {
    return api.post<RetryResponse>(
      `/tasks/${encodeURIComponent(taskId)}/articles/${encodeURIComponent(articleId)}/retry`,
      undefined,
      signal
    );
  }
};
